<template>
  <div class="year-main-content">
    <div class="year-top-image" v-bind:style="{ backgroundImage: 'url(' + require('@/assets/' + topImage) + ')' }">
    <div class="year-overlay"><span>2006</span></div>
    </div>
    <div class="view-wrap yr2006">


<FullYearStats fullGames='16' fullCompletions='356' fullAttempts='554' fullYards='4,418' fullPct='64.3' fullTDs='26' fullINTs='11' fullYPG='276.1' fullRating='96.2'></FullYearStats>

  <div class="year-summary-wrapper">
    <div class="triangle-top-left"></div>
    <div class="triangle-bottom-right"></div>
    <div class="year-summary">
    

      <div class="year-summary-text-flex">
      <h1 class="content-headline">BREES LIGHTS IT UP HIS FIRST YEAR FOR THE SAINTS</h1>

      <div class="copy-paragraph">
        The Saints finished the 2005 season with a 3-13 record, dealing with the lingering aftermath of Hurricane Katrina while splitting home games between LSU's Tiger Stadium and the Alomodome in San Antonio.
        <br/><br/>

      The uncertainty of the city of New Orleans and Drew Brees, both still recovering from extreme trauma, would temper expectations to the point where Saints fans were happy simply having their team finally back at home in the Superdome.<br/><br/>

      
      The theraputic effect of a nostalgic homecoming quickly grew into something bigger, as it became apparent that Saints fans had a team that could compete with the best in the NFL.<br/><br/>

      The Saints finished the 2006 season as 10-6 NFC South Division champions. Brees would have his best season to date, throwing for 4,418 yards and bringing the Saints to their first NFC Championship game in franchise history.<br/><br/>


<VideoExternal button="Video1" vidName="9 for No. 9 - A Champions Journey - Chapter 5" vidUrl="https://youtu.be/SkDr0FF4yac">WATCH: 9 for No. 9 - A Champions Journey - Chapter 5: Rebirth in New Orleans</VideoExternal>

      <br/><br/>


      </div>

      <div class="copy-paragraph">
      <img :src="require('@/assets/brees-2006-img-in-copy.jpg')" style="width:100%;" alt="Drew Brees with Sean Payton and Mickey Loomis at his Saints introduction">
      </div>

      <div class="awards-wrapper">
        <div class="awards-headline">2006 Awards</div>
        <ul>

          <li><img :src="require('@/assets/nfl-logo.svg')" alt="NFL Logo"> 1st Team All-Pro (AP, PFW, SN, SI, UW)</li>
          <li><img :src="require('@/assets/pro-bowl.png')" alt="Pro Bowl Logo"> 2006 Pro Bowl Starter</li>
          <li><img :src="require('@/assets/walter-payton-moy.png')" alt="Walter Payton Patch Logo"> Co-NFL Walter Payton Man of the Year</li>
          <li><img :src="require('@/assets/pfwa-award.jpg')" alt="Pro Football Writers of America Logo"> PFWA All-NFC</li>
          <li><img :src="require('@/assets/si-award.jpg')" alt="Sports Illustrated Logo"> Sports Illustrated (Dr. Z) NFL Most Valuable Player</li>
          <li><img :src="require('@/assets/fedex-air.jpg')" alt="FedEx Logo"> FedEx Air Player of the Year</li>
          <li><img :src="require('@/assets/101-award.png')" alt="101 Awards Logo"> Committee of 101 - NFC Offensive Player of the Year</li>
          <li><img :src="require('@/assets/nfl-alumni.png')" alt="NFL Alumni Logo"> NFL Alumni QB of the Year</li>
          
        </ul>
        <div class="awards-legend">
<b>AP</b> - Associated Press, <b>CN</b> - College & Pro Football Weekly, <b>FD</b> -Football Digest, <b>FN</b> -Football News, <b>FW</b> - Professional Football Writers of America, <b>NE</b> - Newspaper Enterprise Association, <b>NY</b> - New York Daily News, <b>PFWA</b> - Pro Football Writers of America, <b>PW</b> - Pro Football Weekly(1992-2012,choices combined with Pro Football Writers of America), <b>SI</b> - Sports Illustrated, <b>SN</b> - Sporting News, <b>UP</b> - United Press International, <b>UW</b> - USA Today/Sports Weekly
        </div>
      </div> 


      </div> <!--end text-flex-->
    </div>
  </div>


   <div class="bubble-chart-wrapper chart-light">
      <h2 class="chart-headline">2006 Top Rated Passers</h2>
      <BubbleChart :chart-data="dataBubble1" :options="dataOptions3" style="height:400px;"></BubbleChart>
    </div>


<div class="touchdowns-header-wrapper">
  <h1><img src="https://nolaprodigital.com/saints/brees500/images/referee-icon-white.png" alt="Drew Brees 2006 Touchdown Tally"> 2006 TOUCHDOWN TALLY</h1>
</div>



</div>


<TDsByYear :tds="this.tds"></TDsByYear>



<flickity ref="flickity" :options="flickityOptions">
  <div class="carousel-cell"><img :src="require('@/assets/' + image1)" alt="Drew Brees in 2006 - Slide1"></div>
  <div class="carousel-cell"><img :src="require('@/assets/' + image2)" alt="Drew Brees in 2006 - Slide2"></div>
  <div class="carousel-cell"><img :src="require('@/assets/' + image3)" alt="Drew Brees in 2006 - Slide3"></div>
  <div class="carousel-cell"><img :src="require('@/assets/' + image4)" alt="Drew Brees in 2006 - Slide4"></div>
  <div class="carousel-cell"><img :src="require('@/assets/' + image5)" alt="Drew Brees in 2006 - Slide5"></div>
  <div class="carousel-cell"><img :src="require('@/assets/' + image6)" alt="Drew Brees in 2006 - Slide6"></div>
  <div class="carousel-cell"><img :src="require('@/assets/' + image7)" alt="Drew Brees in 2006 - Slide7"></div>
  <div class="carousel-cell"><img :src="require('@/assets/' + image8)" alt="Drew Brees in 2006 - Slide8"></div>
</flickity>


<div class="year-pagination-wrapper">
  <div class="year-pagination-section year-pagination-prev"><router-link to="/year/2005">«2005</router-link></div>
  <div class="year-pagination-section year-pagination-current">2006</div>
  <div class="year-pagination-section year-pagination-next"><router-link to="/year/2007">2007»</router-link></div>
</div>



    </div>
  </div>
</template>

<script>
// @ is an alias to /src
import StatsFlex from '@/components/StatsFlex.vue'
import Flickity from 'vue-flickity';
import VideoBtn from '@/components/VideoBtn.vue';
import VideoExternal from '@/components/VideoExternal.vue';
import FullYearStats from '@/components/FullYearStats.vue';
import TDsByYear from '@/components/TDsByYear.vue';
import BubbleChart from '@/components/BubbleChart.vue'

import axios from 'axios';

export default {
  name: 'yr2006',
  components: {
    Flickity,
    StatsFlex,
    VideoBtn,
    VideoExternal,
    FullYearStats,
    TDsByYear,
    BubbleChart
  },
  metaInfo: {
    title: 'Drew Brees Stats and Touchdowns from his 2006 season',
    htmlAttrs: {
      lang: 'en'
    }
  },
  data() {
    return {
      tds: {},
      loading: false,
      games: [],
      topImage: "brees-2006-top.jpg",
      image1: "brees-2006-slide-1.jpg",
      image2: "brees-2006-slide-2.jpg",
      image3: "brees-2006-slide-3.jpg",
      image4: "brees-2006-slide-4.jpg",
      image5: "brees-2006-slide-5.jpg",
      image6: "brees-2006-slide-6.jpg",
      image7: "brees-2006-slide-7.jpg",
      image8: "brees-2006-slide-8.jpg",

      flickityOptions: {
            initialIndex: 0,
            prevNextButtons: false,
            pageDots: false,
            resize: true,
            wrapAround: true,
            autoPlay: true

            // any options from Flickity can be used
            }

          } 
        },
  methods: {
    async getTDs() {
      const self = this;
      const response = await axios.get(
        "../../static/td-data.json"
      );
      this.tds = response.data.y2006;
      console.log(this.tds)
    },
    next() {
      this.$refs.flickity.next();
    },

    previous() {
      this.$refs.flickity.previous();
    },
    resize() {
      this.$refs.flickity.resize();
    }
  },

mounted: function() {
    this.getTDs();

    setTimeout(() => {
    this.$refs.flickity.resize();
    }, 2000)

},
created() {

      

       this.dataBubble1 = {
      "datasets": [
      {
        "label": "Drew Brees",
        "backgroundColor": "#101820",
        "borderColor": "#D3BC8D",
        "fill": false,
        "pointBackgroundColor": '#D3BC8D',
        "pointColor": "#D3BC8D",
        
        borderWidth: 3,
        hoverBorderWidth:3,
        "pointHighlightFill": "#D3BC8D",
        data: [
                {
                  x: 96.2,
                  y: 4418,
                  r: 26/1.5
                }
              ]
      },
      {
        "label": "Peyton Manning",
        "backgroundColor": "#fff",
        "borderColor": "#002C5F",
        "fill": false,
        radius: 7,
        hoverRadius: 0,
        borderWidth: 3,
        hoverBorderWidth:3,
        "pointHighlightFill": "#C60C30",
        data: [
                {
                  x: 101.9,
                  y: 4397,
                  r: 31/1.5
                }
              ]
      },
      {
        "label": "Tony Romo",
        "backgroundColor": "#041E42",
        "borderColor": "#869397",
        "fill": false,
        "pointRadius": 7,
        hoverRadius: 0,
        borderWidth: 3,
        hoverBorderWidth:3,
        "pointHighlightFill": "#C60C30",
        data: [
                {
                  x: 95.1,
                  y: 2903,
                  r: 19/1.5
                }
              ]
      },
      {
        "label": "Donovan McNabb",
        "backgroundColor": "#004C54",
        "borderColor": "#A5ACAF",
        "fill": false,
        "pointRadius": 7,
        hoverRadius: 0,
        borderWidth: 3,
        hoverBorderWidth:3,
        "pointHighlightFill": "#C60C30",
        data: [
                {
                  x: 95.5,
                  y: 2647,
                  r: 18/1.5
                }
              ]
      },
      {
        "label": "Carson Palmer",
        "backgroundColor": "#FB4F14",
        "borderColor": "#000",
        "fill": false,
        "pointRadius": 7,
        hoverRadius: 0,
        borderWidth: 3,
        hoverBorderWidth:3,
        "pointHighlightFill": "#C60C30",
        data: [
                {
                  x: 93.9,
                  y: 4035,
                  r: 28/1.5
                }
              ]
      }
      ]
    },
    this.dataOptions3 = {
        "responsive": true,
        "maintainAspectRatio": false,
        title: {
            display: true,
            text: '(Bubble size is Touchdowns)'
        },
        "layout": {
          padding: {
                left: 10,
                right: 10,
                top: 0,
                bottom: 0
          },
        },
        "legend": {
          "position" : "bottom",
            "maxSize" : {
                "height" : 400
            },
            "labels": {
                "fontColor": "black",
                "fontSize": 14,
                "usePointStyle" : true
            }
        },
        tooltips: {
          "mode": "point",
          callbacks: {
              label: function(tooltipItem, data) {
                 var rLabel = data.datasets[tooltipItem.datasetIndex].data[tooltipItem.index].r;
                  var datasetLabel = data.datasets[tooltipItem.datasetIndex].label || '';
                  return datasetLabel + ' : ' + tooltipItem.yLabel.toLocaleString() + ' Yards, ' + tooltipItem.xLabel.toLocaleString() + ' QB Rating, ' + rLabel*1.5 + ' TDs';
              }
          }
        },
        "scales": {
          "yAxes": [{
            scaleLabel: {
              display: true,
              labelString: 'Yards'
            },
            gridLines: {
              color: '#D3BC8D',
              tickMarkLength: 20,
              lineWidth: .2
                },
            "ticks": {
              "fontColor": 'black',
              callback: function(value, index, values) {
                        return value.toLocaleString();
                    },
            },
          }],
          "xAxes": [{
            scaleLabel: {
              display: true,
              labelString: 'QB Rating'
            },
            gridLines: {
              color: '#D3BC8D',
              tickMarkLength: 20,
              lineWidth: .2
            },
            "ticks": {
              
              "fontColor": 'black'
            },
          }]
        }
    }

    }
}
</script>

<style>

.year-top-image > img {
  width:100%;
}


@media (max-width:767px;) {
  .year-main-content {
  margin-top:35px;
  }
}
</style>


// WEBPACK FOOTER //
// src/views/yr2006.vue